// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"66f824fc","399":"c7dfe37e","573":"b65553b8","588":"244107bb","683":"f66d9a08","784":"831f2977","787":"bed44058"}[chunkId] + ".chunk.js";
};